import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"],
    _excluded2 = ["cx", "getStyles", "selectProps", "theme", "innerRef", "isHidden", "isDisabled"],
    _excluded3 = ["children"],
    _excluded4 = ["styles"];
import React from "react";
import Base, { components } from "react-select";
import AsyncBase from "react-select/async";
import { getColor } from "@chakra-ui/theme-tools";
import AutosizeInput from "react-input-autosize";
import _theme from "../theme/hometimeTheme";
import { Subheading } from "../core/typography";
import { jsx as ___EmotionJSX } from "@emotion/react";

var Option = function Option(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (props.selectProps.renderOption) {
    return props.selectProps.renderOption(Object.assign({}, props, {
      children: children
    }));
  }

  return ___EmotionJSX(components.Option, props, children, props.data.description && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("br", null), ___EmotionJSX(Subheading, {
    size: "xs",
    color: props.isSelected ? "white" : "gray.700"
  }, props.data.description)));
};

var CustomInput = function CustomInput(_ref2) {
  var cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      selectProps = _ref2.selectProps,
      theme = _ref2.theme,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var inputStyle = function inputStyle(isHidden) {
    return {
      label: "input",
      background: 0,
      border: 0,
      fontSize: "inherit",
      opacity: isHidden ? 0 : 1,
      outline: 0,
      padding: 0,
      color: "inherit"
    };
  }; // hacky: rollup makes AutosizeInput an esmodule object after compile


  var InputComponent = typeof AutosizeInput === "object" && AutosizeInput.default ? AutosizeInput.default : AutosizeInput;
  return ___EmotionJSX(InputComponent, _extends({}, props, {
    ref: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }));
};

var ValueContainer = function ValueContainer(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  if (props.selectProps.renderValue) {
    return props.selectProps.renderValue(Object.assign({}, props, {
      children: children
    }));
  }

  return ___EmotionJSX(components.ValueContainer, props, children);
};

var Select = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var styles = _ref4.styles,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  var selectStyles = {
    control: function control(base, state) {
      return Object.assign({}, base, {
        borderColor: props.isInvalid ? getColor(_theme, "red.200") : getColor(_theme, "gray.400"),
        boxShadow: props.isInvalid ? " 0 0 0 1px " + getColor(_theme, "red.200") : "none",
        ":hover": {
          borderColor: props.isInvalid ? getColor(_theme, "red.200") : getColor(_theme, "gray.500")
        },
        backgroundColor: state.isDisabled ? getColor(_theme, "gray.200") : getColor(_theme, "white"),
        fontSize: "0.875rem"
      });
    },
    option: function option(base) {
      return Object.assign({}, base, {
        padding: props.renderOption ? "0" : base.padding,
        fontSize: "0.875rem"
      });
    },
    placeholder: function placeholder(base, state) {
      return Object.assign({}, base, {
        color: getColor(_theme, "gray.600"),
        whiteSpace: "nowrap",
        maxWidth: "calc(100% - 8px)",
        overflow: "hidden",
        textOverflow: "ellipsis"
      });
    },
    indicatorSeparator: function indicatorSeparator(base, state) {
      if (!state.isMulti || !state.hasValue) {
        return {
          display: "none"
        };
      }

      return Object.assign({}, base, {
        backgroundColour: getColor(_theme, "gray.500")
      });
    },
    menu: function menu(base, state) {
      return Object.assign({}, base, {
        zIndex: 3
      });
    }
  };
  return ___EmotionJSX(Base, _extends({
    ref: ref,
    theme: function theme(base) {
      return Object.assign({}, base, {
        colors: Object.assign({}, base.colors, {
          primary: getColor(_theme, "teal.200"),
          primary25: getColor(_theme, "gray.200"),
          primary50: getColor(_theme, "teal.100"),
          primary75: getColor(_theme, "teal.200"),
          neutral80: getColor(_theme, "gray.800")
        })
      });
    },
    styles: Object.assign({}, selectStyles, styles),
    components: {
      Option: Option,
      Input: CustomInput,
      ValueContainer: ValueContainer
    }
  }, props));
});
export var Async = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var colourStyles = {
    control: function control(base) {
      return Object.assign({}, base, {
        borderColor: getColor(_theme, "gray.400"),
        ":hover": {
          borderColor: getColor(_theme, "gray.500")
        }
      });
    },
    indicatorSeparator: function indicatorSeparator(base, state) {
      if (!state.isMulti || !state.hasValue) {
        return {
          display: "none"
        };
      }

      return Object.assign({}, base, {
        backgroundColour: getColor(_theme, "gray.500")
      });
    }
  };
  return ___EmotionJSX(AsyncBase, _extends({}, props, {
    ref: ref,
    theme: function theme(base) {
      return Object.assign({}, base, {
        colors: Object.assign({}, base.colors, {
          primary: getColor(_theme, "teal.200"),
          primary25: getColor(_theme, "gray.300"),
          primary50: getColor(_theme, "teal.100"),
          primary75: getColor(_theme, "teal.200"),
          neutral80: getColor(_theme, "gray.800")
        })
      });
    },
    styles: colourStyles,
    components: {
      Option: Option,
      Input: CustomInput,
      ValueContainer: ValueContainer
    }
  }));
});
export var SelectOption = components.Option;
export var SingleValue = components.SingleValue; // exported this as a constant aside from default export as a temporary fix
// for jest not being to resolve default imports inside node_modules/hometime-ui

export { Select };
export default Select;